export const defaultStyle = {
    formTitleWrap: "",
    formTitle: '',
    formDesc: '',
    btnStyle: "bg-[#4f2170] border-[#4f2170] border-2 cursor-pointer block text-[21px] uppercase leading-[21px] text-white tracking-normal my-0 mx-auto  px-[40px] text-center  transition-all rounded-[40px] py-20  hover:border-[#724D8D] hover:border hover:border-2 hover:text-white hover:bg-[#724D8D]"
}
export const formInputStyle = {
    inputContainer:"",
    formWrap:"lg:mx-auto md:mx-auto my-0 w-full  grid grid-cols-1 gap-x-37 gap-y-40 miForm md:max-w-md lg:max-w-lg xl:max-w-xl px-[35px] md:px-[15px]",
    formTitleWrap: "formtitle-wrap lg:max-w-lg xl:max-w-xl px-[35px] md:px-[15px]",
    formTitle: 'text-[24px] leading-[28.8px] md:text-[48px] md:leading-[57.6px]  mb-[35px] text-[#287819] font-Light formHead',
    formDesc: 'max-w-full text-[23px] text-black leading-30 formHeadcont',
    btnStyle: "bg-[#4f2170] border-[#4f2170] border-2 cursor-pointer block text-[21px] uppercase leading-[21px] text-white tracking-normal my-0 mx-auto  px-[40px] text-center  transition-all rounded-[40px] py-20  hover:border-[#724D8D] hover:border hover:border-2 hover:text-white hover:bg-[#724D8D]"
}
export const formInputStyle_WITH_TEXT = {
    ...formInputStyle ,
    formTitle: 'text-[24px] leading-[28.8px] md:text-[48px] md:leading-[57.6px]  mb-[35px] text-[#287819] font-Light formHead',
    formTitleWrap: "block mx-auto md:max-w-md lg:max-w-lg xl:max-w-xl md:px-[15px] px-[35px]",
    formDesc: 'test max-w-full text-[23px] text-black mb-30 leading-30 formHeadcont ',
    formWrap:"lg:mx-auto md:mx-auto my-0 w-full  lg:grid lg:grid-cols-1 gap-x-37 gap-y-40 miForm md:max-w-md lg:max-w-lg xl:max-w-xl px-[35px] md:px-[15px]",
}
export const formInputStyle_6_6 = {
    ...formInputStyle ,
    formWrap:"lg:mx-auto md:mx-auto my-0 w-full grid-cols-1 grid md:grid-cols-2 gap-x-80 gap-y-40 miForm md:max-w-md lg:max-w-lg xl:max-w-xl px-[35px] md:px-[15px]",
}